import React, {Component} from 'react'

import {
  Button,
  Input,
} from 'material-ui'

import {
  Accent,
} from '../helper/consts'

const style = {
  form:{
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    flexDirection: 'row',
  },
  ctaBtn:{
    margin: '5px 21px 5px 5px',
    boxShadow: `0px 10px 50px -5px white`,
    minWidth: '150px',
    minHeight: '50px',
    borderRadius: '50px',
    backgroundColor:'white',
    color:{Accent},
  },
  input:{
    // borderBottom: '2px solid white',
    padding: '16px 9px 16px 0px',
    color: 'white',
    fontSize: '1.1rem',
  }
}

export default class SubscriptionForm extends Component{
  constructor(props){
    super(props);
    this.state = {
      subscribed:false,
      emailAddress:'',
    }
  }


  render(){
    return(
      <div id="mc_embed_signup">
        <form action="//HedBy.us14.list-manage.com/subscribe/post?u=58a87b59108da1d2b61b081fc&amp;id=56011dc6a9" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" className="validate" target="_blank" noValidate>
          <div style={style.form} id="mc_embed_signup_scroll">
          <Input error={this.state.emailError} style={style.input} disabled={this.state.subscribing || this.state.subscribed} onChange={(e)=>{this.setState({emailAddress:e.target.value,emailError:false})}} type="email" value={this.state.emailAddress} name="EMAIL" className="email" id="mce-EMAIL" placeholder="Email..." required />
            <div style={{position: 'absolute', left: '-5000px'}} aria-hidden="true"><input type="text" name="b_58a87b59108da1d2b61b081fc_56011dc6a9" tabIndex="-1" value="" /></div>
            <div className="clear">
              <Button style={style.ctaBtn} color="accent" type="submit" value="Subscribe" name="subscribe" id="mc-embedded-subscribe" className="button">Subscribe</Button>
            </div>
          </div>
        </form>
      </div>
    )
  }
}

// <input onChange={(e)=>{this.setState({emailAddress:e.target.value,emailError:false})}} type="email" value={this.state.emailAddress} name="EMAIL" className="email" id="mce-EMAIL" placeholder="email address" required />
// <input type="submit" value="Subscribe" name="subscribe" id="mc-embedded-subscribe" className="button" />



// WEBPACK FOOTER //
// ./src/components/SubscriptionForm.js